import { TimelineDotClassKey } from '@material-ui/lab/TimelineDot';

const MuiTimelineDot = (): Partial<Record<TimelineDotClassKey, unknown>> => ({
    root: {
        borderWidth: 4,
        marginBottom: 0,
        marginTop: 0,
        minHeight: 12,
        minWidth: 12,
        padding: 0,
    },
});

export default MuiTimelineDot;
